// src-mlr/app.components.js

var components = {
  'landing'             : 'landing',
  'text-landing'        : 'textlanding',
  'video-landing'       : 'videolanding',
  'program-info'        : 'programinfo',
  'webinar'             : 'webinar',
  'custom'              : 'custom',
  'blank'               : 'blank'
}

export default components;